export default class Disable extends CustomEvent {
    constructor(caller) {
        super('disable', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
